import { makeStyles } from "@material-ui/core";


export default makeStyles((theme) => ({
    avatarIcon: {
        backgroundColor: theme.palette.grey[300],
        marginRight: 16,
        "& svg": {
            color: theme.palette.grey[700],
        },
    },
    buttonIcon: {
        color: theme.palette.grey[700],
        cursor: "pointer",
        margin: "0px 16px 4px 16px",
    },
    redButton: {
        backgroundColor: theme.palette.error.main,
        color: "#ffffff",
        marginRight: 6,
        "&:hover": {
            backgroundColor: theme.palette.error.dark,
        },
        flexGrow: 1,
        justifyContent: "space-evenly",
    },
    close: {
        position: "absolute",
        top: 12,
        right: 12,
    },
    header: {
        // fontFamily: "Oswald", // TODO: get the correct font
        fontWeight: 700,
        fontSize: 20,
        color: theme.palette.grey[900],
        textTransform: "uppercase",
        marginBottom: 12,
    },
    popover: {
        borderRadius: 12,
        width: 380,
        marginLeft: 12,
        boxShadow: "0 0 12px rgba(0, 0, 0, 0.1)",
    },
    talkdownMenu: {
        padding: 20,
        color: theme.palette.grey[700],
    },
    callMenu: {
        padding: 8,
        display: "flex",
    },
}));
